module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_5000_10000.ffd7eb7c.png";